import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

const initState = {
  filterStartDate: null,
  filterEndDate: null,
};

export const BookingCancelationListFormData = {
  name: "BookingCancelationListFormData",
  initialState: initState,
  section: [
    {
      title: "MembershipTaskListFormData",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "MembershipTaskListFormData", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2 ",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "filterStartDate",
              label: "Start Date",
              Field_Name: "Start Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "filterStartDate",
              fieldSetting: {
                placeholder: "dd-mmm-yyyy",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-4 validation-left-0 ",
              },
            },
            {
              id: "filterEndDate",
              label: "End Date",
              Field_Name: "End Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "filterEndDate",
              fieldSetting: {
                placeholder: "dd-mmm-yyyy",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-4 validation-left-0 ",
              },
            },
            {
              id: "searchText",
              label: "Search",
              Field_Name: "Search",
              fieldType: FormFieldTypes.INPUT,
              dataField: "searchText",
              fieldSetting: {
                placeholder: "Search",
                allowSpace: false,
              },
              style: {
                containerCss: "ccol-lg-4 col-md-4 validation-left-0",
              },
            },
          ],
        },
      ],
    },
  ],
};

export const BookingCancelationListConfig = {
  columns: [
    {
      name: "Ref. No.",
      fieldName: "bookingReferenceNo",
      allowShort: false,
    },
    {
      name: "Class",
      fieldName: "className",
      allowShort: false,
    },
    {
      name: "Status",
      fieldName: "bookingStatus",
      allowShort: false,
    },
    {
      name: "Type",
      fieldName: "eventTypeName",
      allowShort: false,
    },
    {
      name: "Username",
      fieldName: "attendeeName",
      allowShort: false,
    },
    {
      name: "Email",
      fieldName: "attendeeEmail",
      allowShort: false,
    },
    {
      name: "Request Date",
      fieldName: "requestDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD-MMM-YYYY",
      },
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: false,
      },
      allowShort: false,
    },
  ],
  allowEdit: false,
  isRowSelectable: false,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};
